import styled from "styled-components";
import { device } from "../breakpoints";

export const ScrollBtn = styled.div`
  display: inline-flex;
  width: 24px;
  height: 44px;
  border: 2px #000 solid;
  border-radius: 30px;
  position: relative;
  margin-top: 60px;
  justify-content: center;
  @media ${device.mobile} {
    display: none;
  }
`;

export const ScrollDot = styled.div`
  width: 6px;
  height: 6px;
  border-radius: 100%;
  background: #000;
  animation: bounce 1.5s;
  animation-iteration-count: infinite;

  @keyframes bounce {
    from {
      transform: translate3d(0, 6px, 0);
      opacity: 1;
    }
    to {
      transform: translate3d(0, 26px, 0);
      opacity: 0;
    }
  }
`;
